/** @typedef {import('react').SVGProps<SVGSVGElement> & { size?: number }} WarningIconProps */

/** @param {WarningIconProps} props */
export function WarningIcon({ size = 46, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Warning"
      role="img"
      {...props}
    >
      <circle cx="23" cy="23" r="20" fill="#F6A817" />
      <path
        d="M21.51 13.84Q23 11 24.49 13.84L32.51 29.16Q34 32 30.8 32H15.2Q12 32 13.49 29.16Z"
        fill="none"
        stroke="white"
        strokeWidth="2.4"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path
        d="M23 17V26"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <circle cx="23" cy="29.5" r="1.4" fill="white" />
    </svg>
  );
}
